<template>
  <div 
    class="voice-image" 
    :style="positionStyle" 
    @click="openVoiceInteraction" 
    @mousedown="handleDragStart" 
    @touchstart="handleDragStart" 
    :class="{ 'is-dragging': isDragging }"
  >
    <div class="voice-image-body">
      <div class="voice-image-container">
        <img draggable="false" ref="containImg" :src="getImgUrl" alt="">
      </div>
      <div class="voice-image-tips">
        <span class="voice-tips">
          {{ voiceTips }}
        </span>
      </div>
      <div class="voice-image-name">
        <span class="voice-name" v-if="!isRecording">语音助手</span>
        <img v-else draggable="false" src="https://bigdata.topeti.com/wechatRepository/image/voice-ripple.gif" alt="">
      </div>
    </div>
    <div class="voice-subtitles" v-if="currentTranscription">
      <div class="voice-subtitles-conatiner">
        <span>{{ currentTranscription }}</span>
      </div>
    </div>
    <voicePop ref="voicePop" v-if="isViewPop" @close="close" />
  </div>
</template>

<script>
import voicePop from './voicePop.vue';

export default {
  name: 'voiceImage',
  props: {
    isRecording: { type: Boolean, default: false },
    isTodoBtn: { type: Boolean, default: false },
    ws: {},
    styleTemp: { type: Object, default: () => ({}) },
    currentTranscription: { type: String, default: '' },
    customdeskId: { type: String, default: '' }
  },
  components: { voicePop },
  data() {
    return {
      isDragging: false,
      dragOffsetX: 0,
      dragOffsetY: 0,
      hasMoved: false,
      // 初始状态使用 bottom/right 定位
      positionStyle: {
        position: 'fixed',
        bottom: '32px',
        right: '64px',
        top: 'auto',
        left: 'auto',
        zIndex: 99999,
        transform: 'none'
      },
      isViewPop: false
    }
  },
  computed: {
    voiceTips() {
      if (this.isRecording) return '正在聆听中...';
      if (this.isTodoBtn) return '已收到，请稍后';
      
      const avatarConfig = this.styleTemp?.overAllStyle?.voiceInfo?.avatarConfig;
      if (avatarConfig?.searchVal) {
        return avatarConfig.searchVal;
      }
      return '我是AI助理，需要什么帮忙？';
    },
    getImgUrl() {
      const defaultUrl = 'https://bigdata.topeti.com/PCRepository/mainPlatform/chat/s-enterprise-0.png';
      const info = this.styleTemp?.overAllStyle?.voiceInfo;
      if (info?.avatarConfig) {
        if (info.avatarConfig.avatarId) {
          return `https://bigdata.topeti.com/PCRepository/mainPlatform/chat/s-${info.avatarConfig.avatarId}.png`;
        } else if (info.avatarConfig.halfBodyImage) {
          return `${this.$imgurl}/userfiles/${info.avatarConfig.halfBodyImage}`;
        }
      }
      return defaultUrl;
    }
  },
  watch: {
    hasMoved(newVal) {
      this.$emit('hasMoved', newVal);
    }
  },
  beforeUnmount() {
    this.removeDragListeners();
  },
  methods: {
    close() {
      this.isViewPop = false;
    },
    openVoiceInteraction() {
      // 如果正在拖拽或刚刚结束拖拽，不触发点击
      if (this.hasMoved) return;
      this.isViewPop = true
      const rect = this.$refs.containImg.getBoundingClientRect();
      
      // 注意：既然 .voice-image 是 fixed 定位，
      // 获取到的 rect.left/top 就是相对于视口的位置，无需加 window.scrollY
      const obj = {
        position: {
          left: rect.left + 'px',
          top: rect.top + 'px',
          width: rect.width + 'px',
          height: rect.height + 'px'
        },
        config: this.styleTemp,
        id: this.customdeskId
      };
      
      this.$nextTick(() => {
        this.$refs.voicePop.open(obj);
      })
    },

    handleDragStart(e) {
      const clientX = e.touches ? e.touches[0].clientX : e.clientX;
      const clientY = e.touches ? e.touches[0].clientY : e.clientY;

      this.isDragging = true;
      this.hasMoved = false; // 按下时先重置

      const rect = this.$el.getBoundingClientRect();
      this.dragOffsetX = clientX - rect.left;
      this.dragOffsetY = clientY - rect.top;

      // 关键：开始拖拽后，立即将 bottom/right 设为 auto，防止定位冲突
      this.positionStyle.bottom = 'auto';
      this.positionStyle.right = 'auto';
      this.positionStyle.left = `${rect.left}px`;
      this.positionStyle.top = `${rect.top}px`;

      document.addEventListener('mousemove', this.handleDragMove);
      document.addEventListener('mouseup', this.handleDragEnd);
      document.addEventListener('touchmove', this.handleDragMove, { passive: false });
      document.addEventListener('touchend', this.handleDragEnd);
    },

    handleDragMove(e) {
      if (!this.isDragging) return;
      
      // 如果有移动距离，判定为移动
      this.hasMoved = true;

      const clientX = e.touches ? e.touches[0].clientX : e.clientX;
      const clientY = e.touches ? e.touches[0].clientY : e.clientY;

      let newX = clientX - this.dragOffsetX;
      let newY = clientY - this.dragOffsetY;

      // 简单的边界限制（可选）
      const winW = window.innerWidth;
      const winH = window.innerHeight;
      newX = Math.max(0, Math.min(newX, winW - 120));
      newY = Math.max(0, Math.min(newY, winH - 120));

      this.positionStyle.left = `${newX}px`;
      this.positionStyle.top = `${newY}px`;
    },

    handleDragEnd() {
      this.isDragging = false;
      this.removeDragListeners();
      
      // 延迟重置 hasMoved，确保不会立即触发 click 事件
      setTimeout(() => {
        this.hasMoved = false;
      }, 100);
    },

    removeDragListeners() {
      document.removeEventListener('mousemove', this.handleDragMove);
      document.removeEventListener('mouseup', this.handleDragEnd);
      document.removeEventListener('touchmove', this.handleDragMove);
      document.removeEventListener('touchend', this.handleDragEnd);
    }
  }
}
</script>

<style scoped lang="scss">
.voice-image {
  width: 120px;
  height: 120px;
  /* 基础样式移入 positionStyle 动态控制，但保留 fallback */
  position: fixed; 
  user-select: none;
  touch-action: none; // 优化移动端拖拽体验

  &.is-dragging {
    transition: none;
    z-index: 99999;
  }

  &-body {
    cursor: pointer;
    width: 100%;
    height: 120px;
    background: url('https://bigdata.topeti.com/wechatRepository/image/voice-bg.png') no-repeat;
    padding: 10px;
    box-sizing: border-box;
    background-size: contain;
    position: relative;
  }

  &-container {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    img {
      width: 65px;
      margin-left: 15px;
      margin-top: 10px;
      pointer-events: none; // 防止图片干扰拖拽
    }
  }

  &-tips {
    height: 40px;
    background: url('https://bigdata.topeti.com/wechatRepository/image/voice-tips.png') no-repeat;
    width: 206px;
    background-size: cover;
    position: absolute;
    top: -10px;
    left: -50%;
    text-align: center;
    padding-top: 6px;
    box-sizing: border-box;
    pointer-events: none;

    .voice-tips {
      display: block;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      color: #FBFBFD;
      font-weight: 400;
      font-size: 12px;
    }
  }

  &-name {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      height: 47px;
      position: relative;
      bottom: -8px;
    }
    .voice-name {
      color: transparent;
      font-weight: 400;
      font-size: 20px;
      background: linear-gradient(90deg, #9a69fc 0%, #5570f8 100%);
      -webkit-background-clip: text;
      background-clip: text;
    }
  }

  .voice-subtitles {
    width: 250px;
    box-shadow: 0 0 0 2px rgba(135, 206, 250, 0.8), 0 0 10px rgba(147, 112, 219, 0.4), 0 0 20px rgba(0, 191, 255, 0.3);
    left: -70%;
    margin-top: 10px;
    position: relative;
    border-radius: 10px;
    background: #e6e9f0;

    &-conatiner {
      border-radius: 10px;
      padding: 15px;
      backdrop-filter: blur(2px);
      background-color: rgba(255, 255, 255, 0.2);
    }
    span {
      color: #000;
      font-size: 14px;
      line-height: 1.4;
      word-break: break-all;
    }
  }
}
</style>